// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","804":"tas","811":"charge","996":"info"}[chunkId] + "." + {"443":"55a82821","804":"6bfa219e","811":"7617d1ff","996":"c5c843e1"}[chunkId] + ".css";
};